// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'os-windows';

export const Component = () => (
  <path d='M1 12.973h9.34v8.908L1 20.636v-7.663Zm0-8.86 9.34-1.293v9.004H1v-7.71Zm10.393 8.86h12.404V23.75l-12.404-1.724v-9.052Zm0-10.296L23.797 1v10.823H11.393V2.676Z' />
);

export const viewBox = '0 0 25 25';
